import { render, staticRenderFns } from "./tareasp.vue?vue&type=template&id=4a6dfc26&scoped=true"
import script from "./tareasp.vue?vue&type=script&lang=js"
export * from "./tareasp.vue?vue&type=script&lang=js"
import style0 from "./tareasp.vue?vue&type=style&index=0&id=4a6dfc26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6dfc26",
  null
  
)

export default component.exports